import { Container } from "react-bootstrap";
import "./css/style.css";
import Marquee from "react-fast-marquee";
export default function Hello(params) {
    return (
        <>
            <section className="hello">
                <Container className="flex">
                    <h1 className="hello_title">
                        ПРОДАЖА СВЕТОДИОДНЫХ <br /> LED ЭКРАНОВ
                    </h1>
                    <p className="hello_ps t24 mb-5 mt-5">Купите ультратонкий Led экран с доставкой, установкой и техническим обслуживанием</p>
                    <a href="#kwiz">
                        {" "}
                        <button className="button t16 flex">рассчитать стоимость</button>
                    </a>
                </Container>
            </section>
            <Marquee className="hello_marquee flex">
                <MarqueeItem />
                <MarqueeItem />
                <MarqueeItem />
                <MarqueeItem />
                <MarqueeItem />
                <MarqueeItem />
            </Marquee>
        </>
    );
}

function MarqueeItem(params) {
    return (
        <div className="hello_marquee_item flex">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75982 0.725208C8.7936 0.424931 9.2064 0.424931 9.24018 0.725208L9.52334 3.24427C9.88899 6.49705 12.3186 9.06163 15.4001 9.44758L17.7866 9.74648C18.0711 9.78214 18.0711 10.2179 17.7866 10.2535L15.4001 10.5524C12.3186 10.9384 9.88899 13.5029 9.52334 16.7557L9.24018 19.2748C9.2064 19.5751 8.7936 19.5751 8.75982 19.2748L8.47666 16.7557C8.11101 13.5029 5.68142 10.9384 2.59983 10.5524L0.213355 10.2535C-0.0711185 10.2179 -0.0711185 9.78214 0.213355 9.74648L2.59983 9.44758C5.68142 9.06163 8.11101 6.49705 8.47666 3.24427L8.75982 0.725208Z"
                    fill="url(#paint0_linear_248_16)"
                />
                <defs>
                    <linearGradient id="paint0_linear_248_16" x1="3.65398" y1="-0.404939" x2="19.8997" y2="18.7801" gradientUnits="userSpaceOnUse">
                        <stop offset="0.164" stopColor="#10C7EF" />
                        <stop offset="0.869" stopColor="#8859F5" />
                    </linearGradient>
                </defs>
            </svg>
            <p className="t16">От 60 000 ₽/м² стоимость продажи</p>
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75982 0.725208C8.7936 0.424931 9.2064 0.424931 9.24018 0.725208L9.52334 3.24427C9.88899 6.49705 12.3186 9.06163 15.4001 9.44758L17.7866 9.74648C18.0711 9.78214 18.0711 10.2179 17.7866 10.2535L15.4001 10.5524C12.3186 10.9384 9.88899 13.5029 9.52334 16.7557L9.24018 19.2748C9.2064 19.5751 8.7936 19.5751 8.75982 19.2748L8.47666 16.7557C8.11101 13.5029 5.68142 10.9384 2.59983 10.5524L0.213355 10.2535C-0.0711185 10.2179 -0.0711185 9.78214 0.213355 9.74648L2.59983 9.44758C5.68142 9.06163 8.11101 6.49705 8.47666 3.24427L8.75982 0.725208Z"
                    fill="url(#paint0_linear_248_16)"
                />
                <defs>
                    <linearGradient id="paint0_linear_248_16" x1="3.65398" y1="-0.404939" x2="19.8997" y2="18.7801" gradientUnits="userSpaceOnUse">
                        <stop offset="0.164" stopColor="#10C7EF" />
                        <stop offset="0.869" stopColor="#8859F5" />
                    </linearGradient>
                </defs>
            </svg>
            <p className="t16">От 2-х недель сроки поставки</p>
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75982 0.725208C8.7936 0.424931 9.2064 0.424931 9.24018 0.725208L9.52334 3.24427C9.88899 6.49705 12.3186 9.06163 15.4001 9.44758L17.7866 9.74648C18.0711 9.78214 18.0711 10.2179 17.7866 10.2535L15.4001 10.5524C12.3186 10.9384 9.88899 13.5029 9.52334 16.7557L9.24018 19.2748C9.2064 19.5751 8.7936 19.5751 8.75982 19.2748L8.47666 16.7557C8.11101 13.5029 5.68142 10.9384 2.59983 10.5524L0.213355 10.2535C-0.0711185 10.2179 -0.0711185 9.78214 0.213355 9.74648L2.59983 9.44758C5.68142 9.06163 8.11101 6.49705 8.47666 3.24427L8.75982 0.725208Z"
                    fill="url(#paint0_linear_248_16)"
                />
                <defs>
                    <linearGradient id="paint0_linear_248_16" x1="3.65398" y1="-0.404939" x2="19.8997" y2="18.7801" gradientUnits="userSpaceOnUse">
                        <stop offset="0.164" stopColor="#10C7EF" />
                        <stop offset="0.869" stopColor="#8859F5" />
                    </linearGradient>
                </defs>
            </svg>
            <p className="t16">Продажа LED экранов</p>
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75982 0.725208C8.7936 0.424931 9.2064 0.424931 9.24018 0.725208L9.52334 3.24427C9.88899 6.49705 12.3186 9.06163 15.4001 9.44758L17.7866 9.74648C18.0711 9.78214 18.0711 10.2179 17.7866 10.2535L15.4001 10.5524C12.3186 10.9384 9.88899 13.5029 9.52334 16.7557L9.24018 19.2748C9.2064 19.5751 8.7936 19.5751 8.75982 19.2748L8.47666 16.7557C8.11101 13.5029 5.68142 10.9384 2.59983 10.5524L0.213355 10.2535C-0.0711185 10.2179 -0.0711185 9.78214 0.213355 9.74648L2.59983 9.44758C5.68142 9.06163 8.11101 6.49705 8.47666 3.24427L8.75982 0.725208Z"
                    fill="url(#paint0_linear_248_16)"
                />
                <defs>
                    <linearGradient id="paint0_linear_248_16" x1="3.65398" y1="-0.404939" x2="19.8997" y2="18.7801" gradientUnits="userSpaceOnUse">
                        <stop offset="0.164" stopColor="#10C7EF" />
                        <stop offset="0.869" stopColor="#8859F5" />
                    </linearGradient>
                </defs>
            </svg>
            <p className="t16">Фасадные LED экраны</p>
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75982 0.725208C8.7936 0.424931 9.2064 0.424931 9.24018 0.725208L9.52334 3.24427C9.88899 6.49705 12.3186 9.06163 15.4001 9.44758L17.7866 9.74648C18.0711 9.78214 18.0711 10.2179 17.7866 10.2535L15.4001 10.5524C12.3186 10.9384 9.88899 13.5029 9.52334 16.7557L9.24018 19.2748C9.2064 19.5751 8.7936 19.5751 8.75982 19.2748L8.47666 16.7557C8.11101 13.5029 5.68142 10.9384 2.59983 10.5524L0.213355 10.2535C-0.0711185 10.2179 -0.0711185 9.78214 0.213355 9.74648L2.59983 9.44758C5.68142 9.06163 8.11101 6.49705 8.47666 3.24427L8.75982 0.725208Z"
                    fill="url(#paint0_linear_248_16)"
                />
                <defs>
                    <linearGradient id="paint0_linear_248_16" x1="3.65398" y1="-0.404939" x2="19.8997" y2="18.7801" gradientUnits="userSpaceOnUse">
                        <stop offset="0.164" stopColor="#10C7EF" />
                        <stop offset="0.869" stopColor="#8859F5" />
                    </linearGradient>
                </defs>
            </svg>
            <p className="t16">Рекламные щиты</p>
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.75982 0.725208C8.7936 0.424931 9.2064 0.424931 9.24018 0.725208L9.52334 3.24427C9.88899 6.49705 12.3186 9.06163 15.4001 9.44758L17.7866 9.74648C18.0711 9.78214 18.0711 10.2179 17.7866 10.2535L15.4001 10.5524C12.3186 10.9384 9.88899 13.5029 9.52334 16.7557L9.24018 19.2748C9.2064 19.5751 8.7936 19.5751 8.75982 19.2748L8.47666 16.7557C8.11101 13.5029 5.68142 10.9384 2.59983 10.5524L0.213355 10.2535C-0.0711185 10.2179 -0.0711185 9.78214 0.213355 9.74648L2.59983 9.44758C5.68142 9.06163 8.11101 6.49705 8.47666 3.24427L8.75982 0.725208Z"
                    fill="url(#paint0_linear_248_16)"
                />
                <defs>
                    <linearGradient id="paint0_linear_248_16" x1="3.65398" y1="-0.404939" x2="19.8997" y2="18.7801" gradientUnits="userSpaceOnUse">
                        <stop offset="0.164" stopColor="#10C7EF" />
                        <stop offset="0.869" stopColor="#8859F5" />
                    </linearGradient>
                </defs>
            </svg>
            <p className="t16">LED пилоны для торговых центров</p>
        </div>
    );
}
